let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hauGX")).then(() => parcelRequire('5tap4'));